<template>
<div>
    <base-header v-once pageName="내고객보기" :prevBtnShow="true" history="main"></base-header>

    <section id="wrap">
        <ul class="tab tab-fix">
            <li><button type="button" @click="changeTab('first')" :class="{ current : activeTab == 'first'}">고객으로 보기</button></li>
            <li><button type="button" @click="changeTab('second')" :class="{ current : activeTab == 'second'}">계약으로 보기</button></li>
        </ul>
        <div class="search">
            <input type="search" class="search" id="searchCustNm" :value="searchCustNm" v-on:input="checkText($event)" @keyup.enter="conditionSearch" placeholder="이름, 휴대폰번호">
            <button type="button" class="search" title="검색" @click="conditionSearch"></button>
            <button type="button" class="search-detail" :class={choice:searchDetailYn}  title="상세검색" @click="popDetailSearch"></button>
            <base-selectbox v-if="COG01Yn" selectName="EP선택"
                :default="epName"
                v-on:selectSearch="selectSearch"
                v-on:returnSeleted="setEpName"
                :options="myOrgList"
                :selectedAlways="true"
            ></base-selectbox>

            <p>
                <span class="checkbox circle">
                    <input type="checkbox" name="all" id="sample" @change="selectAll" v-model="allSelected">
                    <label for="sample"><em>{{ totCnt }}</em>건</label>
                </span>
            </p>

            <base-sort selectName="정렬선택"
                v-on:sortVal="sortVal"
                :options="sortOption"
				:default="0"
            ></base-sort>

            <base-selectmenu selectName="부가기능"
                v-on:addOn="go"
                :options="addFunctionOption"
            ></base-selectmenu>
            <!-- <button type="button" class="more" title="부가기능"></button> -->
        </div>

        <ul class="myCus-list" v-if="this.custList.length > 0">
            <li v-for="(cust, index) in custList" :key="index" @click="cusCurrent(cust)" :class="{ 'check': cust.selected }">
                <p>
                    <em :class="{contract: cust.custDivDetail == 'SCD01', prospect: cust.custDivDetail == 'SCD02', mom: cust.custDivDetail == 'SCD03', exp: cust.custDivDetail == 'SCD04' }" @click.stop="detailView(index)">{{cust.custDivDetailNm}}</em>
                    <span @click.stop="detailView(index)">{{cust.custNm}}</span>
                    <button type="button" class="map" title="주소" @click.stop="showAddr(cust.kwsad1)" v-if="cust.kwsad1 != null"></button>
                    <button type="button" class="tel" title="전화" @click.stop="call(cust)"></button>
                    <button type="button" class="email" title="문자" @click.stop="sms(cust)"></button>
                    <button type="button" class="favourite" :class="{ chk: cust.bookmarkYn == 'Y'? true : false }" title="즐겨찾기" @click.stop="updateBkmrYn(index)"></button>
                </p>
                <p v-if="'Y' == cust.delivdtYn | 'Y' == cust.concexpydyYn | 'Y' == cust.jindandtYn">
                    <i v-if="'Y' == cust.delivdtYn">배송완료</i>
                    <i v-if="'Y' == cust.concexpydyYn">계약만료예정</i>
                    <i v-if="'Y' == cust.jindandtYn">진단재검사</i>
                </p>
                <div v-if="cust.children">
                    <span v-for="(children, index2) in cust.children" :key="index2">{{childForm(children.cdrnNm,children.cdrnSex,children.cdrnAge)}}</span>
                </div>
                <!-- <div style="display:block;" v-if="listTyp == 'S' && !jsonArrayStringIsEmpty(test)">
                    <span style="display:block; white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                        v-for="(prd, idx) in toObject(test)" :key="idx"
                    >{{prd.prdtnm}}</span>
                </div> -->
            </li>
        </ul>
        <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
            <div slot="no-more"></div>
            <div slot="no-results">
                <div class="search-resutl-None">
                    <p>등록된 고객이 없습니다.<br/>다시 검색해 주세요.</p>
                </div>
            </div>
        </infinite-loading>
        <!-- 2026.09.18 챗봇 버튼-->
        <div class="fltMn">
            <button type="button" class="chatbot allow-click" @click="chatbot"></button>
        </div>
        <!--// 2026.09.18 챗봇 버튼-->
    </section>


    <template v-if="saveList">
        <div class="dim">
            <div class="botWrap list-save">
                <h6>목록 저장하기</h6>
                <div class="save">
                    <input type="text" ref="titl" id="titl" :value="titl" v-on:input="checkText($event)" placeholder="타이틀을 입력해주세요.">
                    <button type="button" @click="saveMyCustList">확인</button>
                </div>
                <button type="button" class="close" @click="hideListView">닫기</button>
            </div>
        </div>
    </template>

    <template v-if="listView">
        <div class="dim">
            <div class="botWrap list-save">
                <h6>저장 목록보기</h6>
                <ul class="list">
                    <li v-for="(savedCustMaster, index) in savedCustMasterList" :key="index" @click="getSavedCustList(index)">
                        <em>{{ savedCustMaster.crtnDttm }}</em>
                        <button type="button">{{ savedCustMaster.titl }}</button>
                        <button type="button" @click.stop="deleteSavedCustList(index)">삭제</button>
                    </li>
                </ul>
                <button type="button" class="close" @click="hideListView">닫기</button>
            </div>
        </div>
    </template>

    <div class="modal" v-if="this.addrView">
        <div class="location">
            <p>{{this.addr}}</p>
            <button type="button" @click="hideAddr">확인</button>
        </div>
    </div>
</div>

</template>

<script>
import _ from 'lodash';
import InfiniteLoading from "vue-infinite-loading";

export default {
  name: "MyCstmrList",
  components: {
    InfiniteLoading
  },
  data() {
      return{
        test: "[{\"prdtnm\":\"스마트라이브러리 프리패스\"},{\"prdtnm\":\"도요새잉글리시 스탠다드\"},{\"prdtnm\":\"도요새잉글리시 프리패스\"},{\"prdtnm\":\"스마트 빨간펜\"},{\"prdtnm\":\"스마트 빨간펜\"},{\"prdtnm\":\"도요새잉글리시 스탠다드\"},{\"prdtnm\":\"스마트라이브러리 멤버십\"}]",
        epName : "",
        activeTab : "first",
        listTyp : "F",
        searchCustNm: "",
        searchUserid: "",
        searchUserids: [],
        custDiv: "",
        fromAge: "",
        toAge: "",
        dgnsStat1: false,
        dgnsStat2: false,
        dgnsStat3: false,
        dgnsStat: [],
        dgnsStatListJsonString: "",
        KEDS: false,
        KEDI: false,
        ELT: false,
        dgnsType: [],
        dgnsTypeListJsonString: "",
        ovrdY: false,
        ovrdN: false,
        ovrdYn: "",
        concexpydyYn: "",
        prodIncludeYn: "",
        prodMaserCd: [],
        prodMaserCdListJsonString: "",
        prodMaserCdListCount: 0,
        selectedProdList: [],
        sortType: "K", // 정렬순서 타입 K: 최근 변경순, C: 계약 만료일순, J: 진단서비스 예정순
        custListSqno: 0, // 저장된 고객 목록 순번
        totCnt:0,
        offset: 0,	 //현재 가지고있는 갯수
        size : 10,	//한번에 가져오는 수
        titl : "",
        custList: [],
        savedCustMasterList:[],
        myCusSelected: [],
        allSelected: false,
        myCusChk: [],
        childData: '',
        saveList: false,
        listView: false,
        COG01Yn:false,
        myOrgList: [],
        addrView: false,
        addr: null,
        sortOption: [{text:'최근 변경순',value:'K'},{text:'계약 만료일순',value:'C'},{text:'진단서비스 예정순',value:'J'}],
        searchDetailYn: false, // 상세검색이 있는지 여부
        baseUrl: "",
        session: this.$store.state.session,
        loginGbn : this.$store.getters.loginGbn, //로그인구분
        addFunctionOption: [
            {text:'선택대상 문자 보내기',value:'sms'},
            {text:'목록 저장하기',value:'saveList'},
            {text:'저장 목록 보기',value:'listView'},
            //{text:'PDF로 보기',value:'pdfView'},
            {text:'고객통합하기',value:'cstIntegration'},
            ],
      };
  },
  watch: { // 팝업창에서 값 받는 부분.
    '$store.state.ui.child'(child) {
        if(child.name == 'sms-send-complete'){  // 문자발송이 완료되었을 때
            this.custList.forEach(element => {
                element.selected = false;
            });
        }
        if(child.name == 'cstmr-detail-search'){  // 상세검색 팝업에서 검색했을  때
            console.log("MyCstmrList.vue cstmr-detail-search data:",this.$store.state.ui.child.data);

            this.custListSqno = 0; // 저장된 고객 목록 순번 초기화

            // 상세 검색조건 설정.
            this.custDiv = this.$store.state.ui.child.data.custDiv;
            this.fromAge = this.$store.state.ui.child.data.fromAge;
            this.toAge = this.$store.state.ui.child.data.toAge;
            this.dgnsStat1 = this.$store.state.ui.child.data.dgnsStat1;
            this.dgnsStat2 = this.$store.state.ui.child.data.dgnsStat2;
            this.dgnsStat3 = this.$store.state.ui.child.data.dgnsStat3;
            this.KEDS = this.$store.state.ui.child.data.KEDS;
            this.KEDI = this.$store.state.ui.child.data.KEDI;
            this.ELT = this.$store.state.ui.child.data.ELT;
            this.ovrdY = this.$store.state.ui.child.data.ovrdY;
            this.ovrdN = this.$store.state.ui.child.data.ovrdN;
            this.concexpydyYn = this.$store.state.ui.child.data.concexpydyYn;
            this.prodIncludeYn = this.$store.state.ui.child.data.prodIncludeYn;
            this.selectedProdList = this.$store.state.ui.child.data.selectedProdList;

            this.searchDetailYn = this.checkDetailSearchYn(); // 상세검색이 있는지 여부

            //console.log("MyCstmrList.vue watch cstmr-detail-search this.dgnsStat", this.dgnsStat);

            this.custSearch();
        }
        if(child.name == 'go-myschedule-reg'){  // 팝업창에서 일정등록 버튼 눌렀을 때

            // console.log("MyCstmrList.vue watch go-myschedule-reg custNm:", this.$store.state.ui.child.data.custNm);
            // console.log("MyCstmrList.vue watch go-myschedule-reg custDivCd:", this.$store.state.ui.child.data.custDivCd);
            var custNm = this.$store.state.ui.child.data.custNm;
            var custDivCd = this.$store.state.ui.child.data.custDivCd;
            var kwkkey = this.$store.state.ui.child.data.kwkkey;

            // 일정등록으로 보낼 파라메터
            var parent = {
                name: 'cstmr-list-schedule-reg-param',
                data: {
                    custNm : custNm,
                    custDivCd : custDivCd,
                    kwkkey : kwkkey
                }
            };
            //console.log("MyCstmrList.vue watch go-myschedule-reg parent:", parent);
            this.$store.commit("SET_UI_PARENT", parent);

            this.$router.push('/mySchedule/myScheduleReg').catch(function() {}).then((() =>window.scrollTo(0,0) ));
        }
    }
  },
  methods: {
    infiniteHandler: function($state) { // 고객목록 일정한 갯수로 계속 조회
      var that = this;

      var parameters = this.getParameters();
      console.log("MyCstmrList.vue infiniteHandler parameters:",parameters);

      this.$api.myCstmr.getMyCstmrList(parameters)
        .then(function(res) {
        //   console.log("MyCstmrList.vue <api.myCstmrList.getMyCstmrList.response> totCnt:",res.totCnt);
        //   console.log("MyCstmrList.vue <api.myCstmrList.getMyCstmrList.response> custList:",res.custList);
          that.totCnt = res.totCnt;
          var list = res.custList;
          if(that.allSelected){
            list.forEach(element => {
                element.selected = true;
            });
          }

          if (list.length) {
            that.offset += that.size;
            that.custList = that.custList.concat(list);
            $state.loaded();
            if (list.length < that.size) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    toObject(str) {
        return JSON.parse(str);
    },
    jsonArrayStringIsEmpty(str) {
        return this.$utils.ui.jsonArrayStringIsEmpty(str);
    },
    checkText: function(e){ // 입력값 정합성 체크
        if(e.target.id == 'searchCustNm' ){
            if(e.target.value.length > 10){
                e.target.value = e.target.value.substr(0,10);
            }else{
                this.searchCustNm = e.target.value;
            }
        }
        if(e.target.id == 'titl' ){
            if(e.target.value.length > 10){
                e.target.value = e.target.value.substr(0,10);
            }else{
                this.titl = e.target.value;
            }
        }
    },
    checkDetailSearchYn: function(){ // 상세검색이 있는지 여부
        if(this.custDiv != "") return true;
        if(this.fromAge != "") return true;
        if(this.toAge != "") return true;
        if(this.dgnsStat1) return true;
        if(this.dgnsStat2) return true;
        if(this.dgnsStat3) return true;
        if(this.KEDS) return true;
        if(this.KEDI) return true;
        if(this.ELT) return true;
        if(this.ovrdY) return true;
        if(this.ovrdN) return true;
        if(this.concexpydyYn != "") return true;
        if(this.prodIncludeYn != "") return true;
        if(this.selectedProdList.length > 0) return true;

        return false;
    },
    setParameters: function(){ // 상세검색 등에서 넘어온 값등을 검색용 파라메터에 셋팅.
         this.dgnsStat = [];
         this.dgnsType = [];
         this.prodMaserCd = [];

        if(this.dgnsStat1){
            this.dgnsStat.push("1");
        }
        if(this.dgnsStat2){
            this.dgnsStat.push("2");
        }
        if(this.dgnsStat3){
            this.dgnsStat.push("3");
        }
        if(this.KEDS){
            this.dgnsType.push("KEDS");
        }
        if(this.KEDI){
            this.dgnsType.push("KEDI");
        }
        if(this.ELT){
            this.dgnsType.push("ELT");
        }

        // 연체상태 선택
        if(this.ovrdY == this.ovrdN){
            this.ovrdYn = "";
        } else if(this.ovrdY){
            this.ovrdYn = "Y";
        } else if(this.ovrdN){
            this.ovrdYn = "N";
        }

        this.selectedProdList.forEach(element => {
            this.prodMaserCd.push(element.salegropCd);
        });

        this.dgnsStatListJsonString = "";
        if(this.dgnsStat.length > 0){
            this.dgnsStatListJsonString = JSON.stringify(this.dgnsStat);
        }

        this.dgnsTypeListJsonString = "";
        if(this.dgnsType.length > 0){
            this.dgnsTypeListJsonString = JSON.stringify(this.dgnsType);
        }

        this.prodMaserCdListJsonString = "";
        if(this.prodMaserCd.length > 0){
            this.prodMaserCdListJsonString = JSON.stringify(this.prodMaserCd);
        }
        this.prodMaserCdListCount = this.prodMaserCd.length;

        // 선택 EP
        if (this.searchUserid === 'ALL') {
            // 전체 선택 시 모든 EP를 배열에 저장
            this.searchUserids = _(this.myOrgList)
                .filter(v => {
                    // 전체 제외
                    return v.value !== 'ALL';
                })
                .map(v => {
                    return v.value;
                })
                .value();
        } else if (this.searchUserid) {
            // EP 1명 선택
            this.searchUserids = [this.searchUserid];
        } else {
            // EP를 선택하지 않고 디폴트 상태에서 조회 시 본인 계약 조회(userid는 백엔드에서 셋팅)
            this.searchUserids = [];
        }
    },
    getParameters: function() { // 검색용 파라메터 조회
        this.setParameters();

        return {
            searchUserid: this.searchUserid,
            searchUserids: this.searchUserids,
            searchCustNm: this.searchCustNm,
            custDiv: this.custDiv,
            fromAge: this.fromAge,
            toAge: this.toAge,
            dgnsStatListJsonString: this.dgnsStatListJsonString,
            dgnsTypeListJsonString: this.dgnsTypeListJsonString,
            ovrdYn: this.ovrdYn,
            concexpydyYn: this.concexpydyYn,
            prodIncludeYn: this.prodIncludeYn,
            prodMaserCdListJsonString: this.prodMaserCdListJsonString,
            prodMaserCdListCount: this.prodMaserCdListCount,
            sortType: this.sortType,
            custListSqno: this.custListSqno,
            listTyp: this.listTyp,
            offset: this.offset,
            size: this.size
        }
    },
    popDetailSearch: function() { // 상세검색 팝업 띄우기
        var parent = {
            name: 'my-cstmr-detal-search-param',
            data: {
                custDiv: this.custDiv,
                fromAge: this.fromAge,
                toAge: this.toAge,
                dgnsStat1: this.dgnsStat1,
                dgnsStat2: this.dgnsStat2,
                dgnsStat3: this.dgnsStat3,
                KEDS: this.KEDS,
                KEDI: this.KEDI,
                ELT: this.ELT,
                ovrdY: this.ovrdY,
                ovrdN: this.ovrdN,
                concexpydyYn: this.concexpydyYn,
                prodIncludeYn: this.prodIncludeYn,
                selectedProdList: this.selectedProdList,
                listTyp: this.listTyp,
            }
        };
        this.$store.commit("SET_UI_PARENT", parent);
        console.log("MyCstmrList.vue popDetailSearch parent", parent);

      this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrList/detailSerach');
    },
    conditionSearch: function() {
        this.custListSqno = 0; // 저장된 고객 목록 순번 초기화
        this.custSearch();
    },
    custSearch: function() { // 고객 목록 조회
      this.totCnt = 0;
      this.offset = 0
      this.size = 10
      this.custList = [];
      this.$refs.InfiniteLoading.stateChanger.reset();
    },
    updateBkmrYn: function (index){ // 북마크 등록/삭제 처리
        // console.log(index);
        // console.log("MyCstmrList.vue updateBkmrYn this.custList[index].kwkkey:",this.custList[index].kwkkey);
        // console.log("MyCstmrList.vue updateBkmrYn this.custList[index].custDiv:",this.custList[index].custDiv);

        var that = this;
        var params = {kwkkey:this.custList[index].kwkkey,custDiv:this.custList[index].custDiv};
        //console.log("MyCstmrList.vue updateBkmrYn params", params);

      if("Y" == this.custList[index].bookmarkYn){
        this.$api.myCstmr.deleteCustBkmr(params)
            .then(function() {
                that.custList[index].bookmarkYn = "N";
            })
            .catch(function() {
                //alert(error.rtMsg);
                that.custList[index].bookmarkYn = "N";
            });
      }
      else{
        this.$api.myCstmr.saveMyCustBkmr(params)
            .then(function() {
                that.custList[index].bookmarkYn = "Y";
                alert(that.custList[index].custNm + " 고객님을 즐겨찾기로 등록했습니다.");
            })
            .catch(function() {
                //alert(error.rtMsg);
                that.custList[index].bookmarkYn = "Y";
            });
      }
    },
    validate() { // 유효성 체크
        if (this.$utils.stringUtil.isNull(this.titl)) {
            alert("타이틀을 입력해주세요.");
            return false;
        }
        if(this.$utils.stringUtil.checkOverLength(this.titl, 32, '타이틀')){
            this.$refs.titl.focus();
            return false;
        }
      return true;
    },
    saveMyCustList: function() { // 고객목록 저장
        var that = this;
        var selectedCustList = [];
        var checkedListYn = "N";

        // console.log("MyCstmrList.vue saveMyCustList this.titl:",this.titl);
        // console.log("MyCstmrList.vue saveMyCustList this.custList:",this.custList);

        if(!this.allSelected){ // 전체 선택이 아닐 때
            this.custList.forEach(element => {
                if(element.selected){
                    selectedCustList.push(element);
                    checkedListYn = "Y"; // 체크된 게 하나라도 있으면 체크된 리스트 저장.
                }
            });
        }
        if(!this.allSelected && checkedListYn == "N"){ // 전체 선택이 아니고, 체크된 게 하나도 없을 때
            alert("저장하려는 고객을 선택해주세요.");
        }else{
            var validate = this.validate();
            if(!validate) {
                return;
            }
            if(!confirm("선택한 고객 목록을 저장하시겠습니까?")){
                return;
            }
            var params = {};
            var jsonString = "";
            if("Y" == checkedListYn){
                jsonString = JSON.stringify(selectedCustList);
                // console.log(selectedCustList);
                // console.log(jsonString);

                params = {titl:this.titl,listTyp:this.listTyp,srcUserid:this.searchUserid,checkedListYn:checkedListYn,jsonString:jsonString};
            }else{ // 전체 선택일 때는 조회 조건을 넘긴다.
                var params1 = {titl:this.titl,listTyp:this.listTyp,srcUserid:this.searchUserid,checkedListYn:checkedListYn};
                var params2 = this.getParameters();

                for (var att1 in params1) {
                    params[att1] = params1[att1];
                }

                for(var att2 in params2)  {
                    params[att2] = params2[att2];
                }

                // console.log(params1);
                // console.log(params2);
                // console.log(params);
            }

            console.log("MyCstmrList.vue saveMyCustList params:",params);

            this.$api.myCstmr.saveMyCustList(params)
            .then(function() {
                that.titl = ""; // 제목 초기화
                that.saveList = false; // 목록 저장하기 레이어 닫기.
                //that.custSearch(); // 재조회.
                that.custList.forEach(element => {
                    if(element.selected == true){
                        element.selected = false;
                    }
                });
                that.allSelected = false;
            })
            .catch(function(error) {
            alert(error.rtMsg);
            });
        }
    },
    getSavedCustMasterList() { // 저장된 고객 목록조회
      var that = this;

      this.$api.myCstmr.getSavedCustMasterList()
        .then(function(res) {
            //console.log("MyCstmrList.vue api.myCstmr.getSavedCustMasterList res:",res);
            that.savedCustMasterList = res;
            if(that.savedCustMasterList.length > 0){
                that.listView = true;
            }else{
                alert("저장된 목록이 없습니다.");
            }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    changeTab: function(name) { // 고객으로 보기 <-> 계약으로 보기
        this.activeTab = name;
        if(this.activeTab == "first"){
            this.listTyp = "F"; // 고객으로 보기
        }else{
            this.listTyp = "S"; // 계약으로 보기
        }

        this.custListSqno = 0; // 저장된 고객 목록 순번 초기화
        this.setDetailSearchConInit(); // 상세검색조건 초기화

        this.custSearch();
    },
    selectAll: function() { // 전체선택 체크버튼 클릭시 전체선택되게 함.
        this.custList.forEach(element => {
            element.selected = this.allSelected;
        });
    },
    cusCurrent: function(item) { // 목록에서 고객선택상태로 만들기
        this.$set(item, 'selected', !item.selected);
        // console.log(item.selected);
        // console.log(this.allSelected);
        if(!item.selected && this.allSelected){
            this.allSelected = false;
            //console.log(this.allSelected);
        }
        //item.$refs.checked = 'checked'
    },
    detailView: function(index){ // 고객상세 창 띄우기
      //console.log("MyCstmrList.vue detailView index", index);
      var selectedUserid = this.custList[index].userid; //사용자 ID
      var selectedKwkkey = this.custList[index].kwkkey; //고객 구분키(가망:CUSTSRNO, 계약:KWKKEY)
      var selectedCustDiv = this.custList[index].custDiv; //SCD01: 계약, SCD02: 가망
    //   console.log("MyCstmrList.vue detailView selectedUserid", selectedUserid);
    //   console.log("MyCstmrList.vue detailView selectedKwkkey", selectedKwkkey);
    //   console.log("MyCstmrList.vue detailView selectedCustDiv", selectedCustDiv);

      this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrView?userId=' + selectedUserid + '&kwkkey=' + selectedKwkkey + '&custDiv=' + selectedCustDiv);
    },
    selectSearch: function(data){ // EP 선택
        const searchUserid = this.searchUserid;

        // 검색조건 초기화
        this.setSearchConInit();

        this.searchUserid = data ? data : searchUserid; // 선택한 EP userid; 없는 경우 디폴트 값 사용
        this.custSearch();
    },
    setEpName: function(data){ // ep 변경시마다 default 변경해서 저장목록 조회시에 변경된 값을 전달할 수 있게 함.
        this.epName = data;
    },
    sortVal: function(data) { // 정렬선택
        //console.log(data);
        this.sortType = data;
        this.custSearch();
    },
    showAddr: function(addr){ // 주소 창 보기
        this.addrView = true;
        this.addr = addr;
    },
    hideAddr: function(){ // 주소 창 닫기
        this.addrView = false;
    },
    call: function(cust){ // 전화걸기 창 띄우기
        var num = cust.kwctlNo;
        location.href = "tel:" + num;

        // 이력저장
        var params = {kwkkey:cust.kwkkey,custDiv:cust.custDiv,memoDiv:"0",memo:"고객님과 전화를 시도하였습니다."};
        console.log("MyCstmrList.vue call params:",params);
        this.saveMyCustMemo(params);
    },
    sms: function(cust){ // 문자 발송 창 띄우기
        var smsUserList = [];
        var smsUser = {};

        smsUser = {encCustNm:cust.encCustNm, encCustTel:cust.encCustTel};
        smsUserList.push(smsUser);

        //console.log("MyCstmrList.vue sms smsUserList:",smsUserList);
        var parent = {
            name: 'sms-user-list',
            data: {smsUserList:smsUserList}
        };
        this.$store.commit("SET_UI_PARENT", parent);

        this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrList/smsSend');

        // 이력저장
        var params = {kwkkey:cust.kwkkey,custDiv:cust.custDiv,memoDiv:"0",memo:"고객님께 문자발송을 시도하였습니다."};
        console.log("MyCstmrList.vue sms params:",params);
        this.saveMyCustMemo(params);
    },
    go: function(data) { // 부가기능
        if(data == 'sms'){ // 문자 보내기
            //console.log('문자 보내기');

            var smsUserList = [];
            var smsUser = {};

            var list = this.custList;
                list.forEach(element => {
                    if(element.selected){
                        smsUser = {encCustNm:element.encCustNm, encCustTel:element.encCustTel};
                        smsUserList.push(smsUser);
                    }
                });

            if(smsUserList.length == 0){
                alert("고객 선택 후 진행해 주세요.");
                return;
            }

          //console.log("MyCstmrList.vue go smsUserList:",smsUserList);
            var parent = {
                name: 'sms-user-list',
                data: {smsUserList:smsUserList}
            };
            this.$store.commit("SET_UI_PARENT", parent);

            this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrList/smsSend');

            list.forEach(element => {
                if(element.selected){
                    // 이력저장
                    var params = {kwkkey:element.kwkkey,custDiv:element.custDiv,memoDiv:"0",memo:"고객님께 문자발송을 시도하였습니다."};
                    console.log("MyCstmrList.vue sms params:",params);
                    this.saveMyCustMemo(params);
                }
            });

        }else if(data == 'saveList'){ // 목록 저장하기
            var checkedListYn = "N";

            if(!this.allSelected){ // 전체 선택이 아닐 때
                this.custList.forEach(element => {
                    if(element.selected){
                        checkedListYn = "Y"; // 체크된 게 하나라도 있으면 체크된 리스트 저장.
                    }
                });
            }
            if(!this.allSelected && checkedListYn == "N"){ // 전체 선택이 아니고, 체크된 게 하나도 없을 때
                alert("고객을 먼저 선택 후, 목록 저장하기를 눌러주세요.");
                return;
            }else{
                this.saveList = true;
            }
        }else if(data == 'listView'){ // 저장 목록보기
            this.getSavedCustMasterList();
        }else if(data == 'pdfView'){ // PDF로 보기
            console.log('PDF로 보기')
            if(!this.searchUserid){
                this.searchUserid = this.$store.state.ui.login.userId;
            }

            this.setParameters();

            var strParam = this.baseUrl + "/api/v1/pdf/mycstmrPdf?searchUserid="+this.searchUserid;
            if(this.searchCustNm)               strParam += "&searchCustNm="+this.searchCustNm;
            if(this.custDiv)                    strParam += "&custDiv="+this.custDiv;
            if(this.fromAge)                    strParam += "&fromAge="+this.fromAge;
            if(this.toAge)                      strParam += "&toAge="+this.toAge;
            if(this.dgnsStatListJsonString)     strParam += "&dgnsStatListJsonString=" + encodeURIComponent(this.dgnsStatListJsonString);
            if(this.dgnsTypeListJsonString)     strParam += "&dgnsTypeListJsonString=" + encodeURIComponent(this.dgnsTypeListJsonString);
            if(this.ovrdYn)                     strParam += "&ovrdYn="+this.ovrdYn;
            if(this.concexpydyYn)               strParam += "&concexpydyYn="+ this.concexpydyYn;
            if(this.prodIncludeYn)              strParam += "&prodIncludeYn="+ this.prodIncludeYn;
            if(this.prodMaserCdListJsonString)  strParam += "&prodMaserCdListJsonString=" + encodeURIComponent(this.prodMaserCdListJsonString);
            if(this.sortType)                   strParam += "&sortType="+ this.sortType;
            if(this.custListSqno)               strParam += "&custListSqno="+ this.custListSqno;
            if(this.listTyp)                    strParam += "&listTyp="+ this.listTyp;

            console.log("pdfView strParam",strParam);

            this.$utils.nativeIf.outbound.outlink(strParam);
        }else if(data == 'cstIntegration'){ // 고객통합하기
            this.$utils.nativeIf.outbound.newPage('/myCstmr/CstIntegration');
        }
    },
    hideListView: function(){ // 목록저장하기 창과 저장 목록보기 창을 닫는다
        this.titl = "";
        this.saveList = false;
        this.listView = false;
    },
    setSearchConInit : function(){ // 검색조건 초기화
        this.searchUserid = "";
        this.searchCustNm = "";
        this.sortType = "K";

        this.custListSqno = 0; // 저장된 고객 목록 순번 초기화
        this.setDetailSearchConInit();// 상세검색조건 초기화
    },
    setDetailSearchConInit : function(){ // 상세검색조건 초기화
        this.custDiv = "";
        this.fromAge = "";
        this.toAge = "";
        this.dgnsStat1 = false;
        this.dgnsStat2 = false;
        this.dgnsStat3 = false;
        this.dgnsStat = [];
        this.KEDS = false;
        this.KEDI = false;
        this.ELT = false;
        this.dgnsType = [];
        this.ovrdY = false;
        this.ovrdN = false;
        this.ovrdYn = "";
        this.concexpydyYn = "";
        this.prodIncludeYn = "";
        this.prodMaserCd = [];
        this.selectedProdList = [];
        this.searchDetailYn = false; // 상세검색이 있는지 여부
    },
    getSavedCustList : function(index){ // 저장 목록 조회
        var listTyp = this.savedCustMasterList[index].listTyp;
        // 탭 변경
        if("F" == listTyp){
            this.changeTab('first');
        }else{
            this.changeTab('second');
        }

        // 검색조건 초기화
        this.setSearchConInit();

        this.custListSqno = this.savedCustMasterList[index].custListSqno; // 저장된 고객 목록 순번
        this.searchUserid = this.savedCustMasterList[index].srcUserid; // 저장된 소스_사용자ID
        this.epName = this.savedCustMasterList[index].srcUserid === 'ALL' ? this.savedCustMasterList[index].srcUsername : this.savedCustMasterList[index].srcUsername + ' ' + this.savedCustMasterList[index].srcUserOrgnzPstnNm; // 소스_사용자명 + 직급

        this.custSearch();

        this.hideListView();
    },
    deleteSavedCustList : function(index){ // 저장 목록 삭제
      if(!confirm("선택하신 목록을 삭제하시겠습니까?")){
        return;
      }else{
        var that = this;
        var params = {userid:this.savedCustMasterList[index].userid,custListSqno:this.savedCustMasterList[index].custListSqno};
        this.$api.myCstmr.deleteSavedCustList(params)
            .then(function() {
                that.custListSqno = 0; // 저장된 고객 목록 순번 초기화
                that.savedCustMasterList.splice(index, 1);
            })
            .catch(function(error) {
            alert(error.rtMsg);
            });
      }
    },
    childForm:function(cdrnNm,cdrnSex,cdrnAge){ // 자녀 이름과 성별, 나이 있는 것만 보여주기
        var childForm = cdrnNm;

        if(!this.$utils.stringUtil.isNull(cdrnSex) && !this.$utils.stringUtil.isNull(cdrnAge)) {
            childForm = childForm + "(" + cdrnSex + " /" + cdrnAge + ")";
        }else if(this.$utils.stringUtil.isNull(cdrnSex) && !this.$utils.stringUtil.isNull(cdrnAge)) {
            childForm = childForm + "(" + cdrnAge + ")";
        }else if(!this.$utils.stringUtil.isNull(cdrnSex) && this.$utils.stringUtil.isNull(cdrnAge)) {
            childForm = childForm + "(" + cdrnSex + ")";
        }

        return childForm;
    },
    base: function(){ // 현재 서버 url 및 로그인 userId 조회
        var that = this;
        this.$api.myCstmr.base()
            .then(function(res) {
                that.baseUrl = res.baseUrl;
                that.searchUserid = res.loginUserid;
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
    },
    saveMyCustMemo: function(params){ // 이력저장.
        console.log("MyCstmrView.vue api.myCstmr.saveMyCustMemo params:",params);

        this.$api.myCstmr.saveMyCustMemo(params)
    },
    chatbot: function(){
        this.$api.chatbot
        .getChatbotToken()
        .then((token) => {
          this.token = token;
          if(this.token != null){
              // this.$utils.nativeIf.outbound.outlink("https://kyowon-chatbot.ax.dalpha.so/#token="+this.token); //달파 토큰 전송
              window.location.href =  `https://kyowon-chatbot.ax.dalpha.so/#token=${encodeURIComponent(token)}&inpath=WAPLE`;
          }else {
              console.log("else token");
          }
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    },
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
      this.base();

      console.log("MyCstmrList.vue mounted this.$store.state.session.orgnzPstn:",this.$store.state.session.orgnzPstn);

      // 지국장일 때는 조직원 정보를 조회한다.
      if("COG01" == this.$store.state.session.orgnzPstn){
        var that = this;
        this.COG01Yn = true;

        var parameters = {
            searchAllYn: 'Y'
        };
        this.$api.myschedule.getMyOrgList(parameters)
        .then(function(res) {
            var myOrgList = [{text: '전체 조회', value: 'ALL'}];
            var myOrg = {};

            var list = res.myOrgList;
                list.forEach(element => {
                    var userName = element.username;
                    if(element.orgnzPstnNm){
                        userName = element.username + ' ' + element.orgnzPstnNm;
                    }
                    myOrg = {text:userName, value:element.userid};
                    myOrgList.push(myOrg);
                });
          that.myOrgList = myOrgList;

          // 자기 자신의 이름과 직급을 기본으로 셋팅해준다.
          that.epName = that.$utils.ui.getUserName() + ' ' + that.$utils.ui.getOrgnzPstnNm();

        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
      }

    // 메인창에서 이름 검색으로 넘어올 때
    var parent = this.$store.getters.parent;
    if(parent.name == 'my-cstmr-list-param'){
        if("" != parent.data.searchCustNm) // 전달받은 고객이름.
        {
            console.log("MyCstmrList.vue mounted this.$store.getters.parent.data.searchCustNm", parent.data.searchCustNm);
            this.searchCustNm = parent.data.searchCustNm;

            // 넘어온 파라메터 초기화
            parent = {
                name: 'my-cstmr-list-param',
                data: {searchCustNm:""}
            };
            this.$store.commit("SET_UI_PARENT", parent);

            this.conditionSearch();
        }
    }
  }
};
</script>
